if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();


      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }


    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;


      this.handleErrorMessage();


      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');


      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];


      const formData = new FormData(this.form);
      const __freeCushionVariantId = formData.get('id');
const __freeCushionLineQty = formData.get('quantity') || 1;


      try {
  const id = parseInt(formData.get('id'), 10);
  const qtyMap = window.__freeCushionQtyByVariantId || {};
  const qty = qtyMap[id];


  if (qty && qty > 0) {
    formData.append('properties[_free_cushions_qty]', String(qty));
  }
} catch (e) {}


      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);


            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }


          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            updateFreeCushionCartAttributes(__freeCushionVariantId, __freeCushionLineQty);


          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');


      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);


      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
// Inject free cushion qty into add-to-cart payload (robust, Dawn safe)
(function () {
  const PROP_KEY = "_free_cushions_qty";


  const originalFetch = window.fetch;


  window.fetch = async function (input, init) {
    try {
      const url =
        typeof input === "string"
          ? input
          : (input && input.url ? input.url : "");


      const isCartAdd = url.includes("/cart/add");


      if (isCartAdd && init && init.body && window.__freeCushionQtyByVariantId) {
        const bodyObj = JSON.parse(init.body);


        if (bodyObj.items && Array.isArray(bodyObj.items)) {
          bodyObj.items.forEach((item) => {
            const qty = window.__freeCushionQtyByVariantId[item.id];
            if (qty && qty > 0) {
              item.properties = item.properties || {};
              item.properties[PROP_KEY] = String(qty);
            }
          });


          init.body = JSON.stringify(bodyObj);
        }
      }
    } catch (e) {
      console.warn("Free cushion injection failed", e);
    }


    return originalFetch.call(this, input, init);
  };
})();
async function updateFreeCushionCartAttributes(variantId, lineQty) {
  try {
    const qtyMap = window.__freeCushionQtyByVariantId || {};
    const perItem = Number(qtyMap[Number(variantId)] || 0);
    const qtyToAdd = perItem * Number(lineQty || 1);


    if (!qtyToAdd || qtyToAdd <= 0) return;


    const todayUk = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(new Date());
    const start = '2025-12-26';
    const end = '2026-02-01';


    if (todayUk < start || todayUk > end) return;


    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await cartRes.json();


    const current = Number((cart.attributes && cart.attributes['Free cushions']) || 0);
    const next = current + qtyToAdd;


    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          'Free cushions': String(next),
          'Free cushions promo': 'Winter promotion, 26 Dec 2025 to 1 Feb 2026'
        }
      })
    });
  } catch (e) {
    console.warn('Free cushions cart attribute update failed', e);
  }
}







